import { INCREMENT_REQUEST_COUNTER_PO, INCREMENT_REQUEST_COUNTER_QUEUE, RESET_REQUEST_COUNTER_PO, RESET_REQUEST_COUNTER_QUEUE } from "./actionTypes";

function incrementRequestCounterPO() {
  return {
    type: INCREMENT_REQUEST_COUNTER_PO
  };
}

function incrementRequestCounterQueue() {
  return {
    type: INCREMENT_REQUEST_COUNTER_QUEUE
  };
}

function resetRequestCounterPO() {
  return {
    type: RESET_REQUEST_COUNTER_PO
  };
}

function resetRequestCounterQueue() {
  return {
    type: RESET_REQUEST_COUNTER_QUEUE
  };
}

export {
  incrementRequestCounterPO,
  incrementRequestCounterQueue,
  resetRequestCounterPO,
  resetRequestCounterQueue
};